export default __webpack_public_path__ + "static/media/dragon.3051978c.png";